const keys = {
  dev: {
    accessKey: "nT5hY3gR5yS0qE5b", // java接口accessKey
    secretKey: "iK8zA3eB6aA7tH3eF5dS4oX9iD5oH8cG", // java接口secretKey
    imageSecurityKey: "vLZo4cqxmhA5klyWyXW5", // 图片服务安全key
    amapWebServiceKey: "", // 高德地图web服务key
    amapWebEndKey: "048993e23968e7737e87da9390830418", // 高德地图web端key(jsapi)
    securityJsCode: "830a4427e2872c781bf8f24a38fb60d9", // 高德地图jscode安全密钥
    ctyunOssAk: "0ab3d8c7a3a5e3d6a849", // 天翼云图片存储ak
    ctyunOssSk: "f2a517104ed977dd81a63de421b3d772cb54fc92", // 天翼云图片存储sk
  },
  test: {
    accessKey: "2osoyipriTOvUtlB", // java接口accessKey
    secretKey: "racr8821lyAPraklxlzIWEfrlwri1uBl", // java接口secretKey
    imageSecurityKey: "tqZcNGVyGdVPpQmrqzrD", // 图片服务安全key
    amapWebServiceKey: "", // 高德地图web服务key
    amapWebEndKey: "048993e23968e7737e87da9390830418", // 高德地图web端key(jsapi)
    securityJsCode: "830a4427e2872c781bf8f24a38fb60d9", // 高德地图jscode安全密钥
    ctyunOssAk: "2b8fa34a4192f3c2c21c", // 天翼云图片存储ak
    ctyunOssSk: "cd6dd95484f276a24f2783b9ef6261920c9675e9", // 天翼云图片存储sk
  },
  prod: {
    accessKey: "2osoyipriTOvUtlB", // java接口accessKey
    secretKey: "racr8821lyAPraklxlzIWEfrlwri1uBl", // java接口secretKey
    imageSecurityKey: "xjwXvByGleYjRZOuu5dO", // 图片服务安全key
    amapWebServiceKey: "", // 高德地图web服务key
    amapWebEndKey: "048993e23968e7737e87da9390830418", // 高德地图web端key(jsapi)
    securityJsCode: "830a4427e2872c781bf8f24a38fb60d9", // 高德地图jscode安全密钥
    ctyunOssAk: "c4c997d294b484304dad", // 天翼云图片存储ak
    ctyunOssSk: "e7f418a63ecc7cffeb4d9508f36b4ec62a6d5bc8", // 天翼云图片存储sk
  },
};

export default keys[process.env.VUE_APP_API_ENV];
